export const MyLeftTabList = [
  {
    id: 1,
    label: '快速创建',
    value: 'quickCreate',
    icon: 'ri-add-large-line',
  },
  {
    id: 2,
    label: '空白模板创建',
    value: 'blankTemplateCreate',
    icon: 'ri-file-text-line',
  },
  {
    id: 3,
    label: '选择视频模板新建',
    value: 'selectVideoTemplateCreate',
    icon: 'ri-film-ai-line',
  },
  {
    id: 4,
    label: 'PPT创建视频',
    value: 'pptCreateVideo',
    icon: 'ri-slideshow-2-line',
  },
  // {
  //   id: 5,
  //   label: '照片数字人视频制作',
  //   value: 'photoDigitalHumanVideo',
  //   icon: 'ri-image-ai-line',
  // },
];

// 空白模板步骤数据
export const BlankTemplateStepsData = [
  [
    {
      title: '1. 选择数字人',
      description: '从数字人资源库中选择适合您品牌的虚拟形象',
      image: "https://client-file.lzwcdm.com/static/image/blanktemplate-step-1.jpg"
    },
    {
      title: '2. 可选择模板创建',
      description: '使用预设场景模板，直接使用或根据需求调整，提高内容制作效率。',
      image: "https://client-file.lzwcdm.com/static/image/blanktemplate-step-2.jpg"
    }
  ],
  [
    {
      title: '3. 选择文案/生成文案',
      description: '可根据自己需求生成文案或使用AI辅助创作工具生成专业文案。',
      image: "https://client-file.lzwcdm.com/static/image/blanktemplate-step-3.jpg"
    },
    {
      title: '4. 选择音色生成视频',
      description: '选择合适的音色或上传自定义语音，自动匹配口型同步，即可生成数字人视频。',
      image: "https://client-file.lzwcdm.com/static/image/blanktemplate-step-4.jpg"
    }
  ]
];


export const PdftoVideoStepsData = [
  [
    {
      title: '1. 上传ppt文件',
      description: '首先上传您需要转换的ppt文件',
      image: "https://client-file.lzwcdm.com/static/image/pdftovideo-step-1.jpg"
    },
    {
      title: '2. 生成解析内容',
      description: '对ppt文件进行解析，生成解析内容',
      image: "https://client-file.lzwcdm.com/static/image/pdftovideo-step-2.png"
    }
  ],
  [
    {
      title: '3. 进行内容配置',
      description: '根据解析内容进行内容配置，包括数字人选择、场景选择、背景音乐选择等',
      image: "https://client-file.lzwcdm.com/static/image/pdftovideo-step-3.png"
    },
    {
      title: '4. 点击生成视频',
      description: '点击生成视频，即可生成视频',
      image: "https://client-file.lzwcdm.com/static/image/pdftovideo-step-4.png"
    }
  ]
];
